import { Record } from 'immutable';

const UsageItemRecord = Record({
  allCoreActivities: undefined,
  completedCoreActivities: undefined,
  completedOn: undefined,
});

class UsageItem extends UsageItemRecord { }

export default UsageItem;



// WEBPACK FOOTER //
// ./data/OnlineHomework/HFUsage/model/onlineUsage/model.js